"use strict";

exports.__esModule = true;
exports.AlertValueFields = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _Translator = require("../../Core/Translator");
var _widget = require("./widget");
var _numericInputMinMaxSanitizer = require("../../../Utils/numericInputMinMaxSanitizer");
var _reactSounds = require("react-sounds");
var _Core = require("../../Core");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var AlertValueFields = exports.AlertValueFields = function AlertValueFields(props) {
  var _element$props2, _element$props3, _element$props4, _element$props5, _element$props6, _element$props8, _element$props9, _element$props0;
  var _useContext = (0, _react.useContext)(_Translator.TranslatorContext),
    translate = _useContext.translate;
  var element = props.element,
    path = props.path,
    elementEditor = props.elementEditor;
  (0, _react.useEffect)(function () {
    var _element$props;
    if (!((_element$props = element.props) != null && _element$props.sound)) {
      elementEditor.setProp(path, "sound", _widget.ALERT_SOUND_DEFAULT);
    }
  }, [element, path, elementEditor]);
  var alertsForSelector = _widget.PREDEFINED_ALERT_SOUNDS.map(function (sound, index) {
    return {
      sound: sound,
      label: "Sound " + (index + 1)
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_reactSounds.SoundProvider, {
    preload: _widget.PREDEFINED_ALERT_SOUNDS,
    initialEnabled: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AlertValueFields.hideLabel.label", "Hide Label"),
    "data-testid": "AlertValueFields.hideLabel.switch",
    checked: ((_element$props2 = element.props) == null ? void 0 : _element$props2.hideLabel) || false,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideLabel", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AlertValueFields.hideTimestamp.label", "Hide Timestamp"),
    "data-testid": "AlertValueFields.hideTimestamp.switch",
    checked: ((_element$props3 = element.props) == null ? void 0 : _element$props3.hideTimestamp) || false,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideTimestamp", e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AlertValueFields.soundNotification.label", "Sound notification on new alert"),
    "data-testid": "AlertValueFields.soundNotification.switch",
    checked: ((_element$props4 = element.props) == null ? void 0 : _element$props4.soundNotification) || false,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "soundNotification", e.target.checked);
    }
  }), ((_element$props5 = element.props) == null ? void 0 : _element$props5.soundNotification) && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("AlertValueFields.sound.label", "Alert Sound")
  }, /*#__PURE__*/_react["default"].createElement(_Core.Selector, {
    dataTestId: "AlertValueFields.sound.selector",
    items: alertsForSelector,
    selected: [((_element$props6 = element.props) == null ? void 0 : _element$props6.sound) || _widget.ALERT_SOUND_DEFAULT],
    getKey: function getKey(e) {
      return e.sound;
    },
    renderItemText: function renderItemText(e) {
      return e.label;
    },
    onSelect: function onSelect(_ref) {
      var selected = _ref[0];
      return elementEditor.setProp(path, "sound", selected.sound);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      var _element$props7;
      return (0, _reactSounds.playSound)((_element$props7 = element.props) == null ? void 0 : _element$props7.sound);
    }
  }, "Play sound")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("AlertValueFields.hideOlderAlerts.label", "Hide alert if older than specified age"),
    "data-testid": "AlertValueFields.hideOlderAlerts.switch",
    checked: ((_element$props8 = element.props) == null ? void 0 : _element$props8.hideOlderAlerts) || false,
    onChange: function onChange(e) {
      return elementEditor.setProp(path, "hideOlderAlerts", e.target.checked);
    }
  }), ((_element$props9 = element.props) == null ? void 0 : _element$props9.hideOlderAlerts) && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("AlertValueFields.alertMaxAgeInMinutes.label", "Alert Display Duration (minutes)"),
    helperText: translate("AlertValueFields.alertMaxAgeInMinutes.helperText", "Alerts older than this many minutes will be hidden")
  }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
    "data-testid": "AlertValueFields.alertMaxAgeInMinutes.input",
    value: ((_element$props0 = element.props) == null ? void 0 : _element$props0.alertMaxAgeInMinutes) || _widget.ALERT_MAX_AGE_DEFAULT,
    min: _widget.ALERT_MAX_AGE_MIN_VALUE,
    max: _widget.ALERT_MAG_AGE_MAX_VALUE,
    stepSize: 1,
    placeholder: translate("AlertValueFields.alertMaxAgeInMinutes.placeholder", "Maximum age in minutes"),
    onValueChange: function onValueChange(value) {
      return elementEditor.setProp(path, "alertMaxAgeInMinutes", (0, _numericInputMinMaxSanitizer.numericInputMinMaxSanitizer)(value, _widget.ALERT_MAX_AGE_MIN_VALUE, _widget.ALERT_MAG_AGE_MAX_VALUE));
    },
    fill: true
  })));
};